// packages/frontend/src/app/App.tsx
// Thin shell that renders the current page (Landing).
import React from 'react';
import LandingPage from './pages/Landing';

export default function App() {
  return <LandingPage />;
}
